import inventoryCounts from './inventoryCounts';
import loading from './loading';
import loadingInventoryCounts from './loadingInventoryCounts';
import vehicles from './vehicles';
import widgetData from './widgetData';

const root = {
	loading,
	loadingInventoryCounts,
	vehicles,
	inventoryCounts,
	widgetData
};

export default root;
